class ErrorAstaNotFound extends Error {
  constructor(message) {
    super(message);
    this.name = "ErrorAstaNotFound";
  }
}

class ErrorSessionExist extends Error {
  constructor(message) {
    super(message);
    this.name = "ErrorSessionExist";
  }
}

class ErrorAdjustPlan extends Error {
  constructor(message) {
    super(message);
    this.name = "ErrorAdjustPlan";
  }
}

export { ErrorAstaNotFound, ErrorSessionExist, ErrorAdjustPlan }